import { EDITOR_ACCENT } from "../../newsletter-editor/editorUiConstants";
import { contentGestioneGridSx, contentPrimaryButtonSx } from "../../content/contentEditorStyles";

export { EDITOR_ACCENT };

export const publishHubGridSx = {
  ...contentGestioneGridSx,
  gridTemplateColumns: { xs: "1fr", lg: "minmax(168px, 180px) minmax(0, 1fr)" },
};

export const publishPrimaryButtonSx = contentPrimaryButtonSx;

export const publishNavItemSx = (active) => ({
  justifyContent: "flex-start",
  textTransform: "none",
  fontWeight: active ? 700 : 500,
  color: active ? EDITOR_ACCENT : "#334155",
  bgcolor: active ? "#eef2ff" : "#fff",
  borderRadius: 1,
  mb: 0.5,
  "&:hover": { bgcolor: active ? "#eef2ff" : "#e2e8f0" },
});
